/** Project lifecycle labels. Render them through `ProjectStatusBadge`. */
export const projectStatusEnum = {
  open: "Aberto",
  completed: "Concluído",
  canceled: "Cancelado",
} as const;

export const projectWorkflowStatusEnum = {
  emission_in_progress: "Em emissão",
  issued: "Emitido",
  reviewed: "Revisado",
  pending_regularization: "Pendente de regularização",
} as const;

// Agricultural Activities List
export const agriculturalActivitylist = [
  { id: "soja", title: "Soja" },
  { id: "milho", title: "Milho" },
  { id: "algodao", title: "Algodão" },
  { id: "arroz", title: "Arroz" },
  { id: "feijao", title: "Feijão" },
  { id: "cafe", title: "Café" },
  { id: "cana", title: "Cana-de-açúcar" },
] as const;

// Livestock Activities List
export const livestockActivitylist = [
  { id: "bovinos_corte", title: "Bovinos de Corte" },
  { id: "bovinos_leite", title: "Bovinos de Leite" },
  { id: "suinos", title: "Suínos" },
  { id: "aves_corte", title: "Aves de Corte" },
  { id: "aves_postura", title: "Aves de Postura" },
  { id: "ovinos", title: "Ovinos" },
  { id: "caprinos", title: "Caprinos" },
] as const;
